const isForeignSupplierLanguage = language =>
    String(language || '')
        .trim()
        .toLowerCase() !== 'spanish'

const isSpanishCertificateLanguage = language =>
    String(language || '')
        .trim()
        .toLowerCase() === 'spanish'

const hasValidTrm = quote => Number(quote?.TRM) > 0

/**
 * Unit price for the receipt certificate.
 * - Domestic (or foreign without TRM): quote.price in COP
 * - Foreign with quote.TRM: quote.price / quote.TRM in USD
 * TRM comes only from Add New Quote and is optional.
 */
const getQuoteUnitPriceForCertificate = (quote, { isForeign } = {}) => {
    const cop = Number(quote?.price) || 0
    if (!isForeign || !hasValidTrm(quote)) return cop
    return cop / Number(quote.TRM)
}

const shouldFormatCertificateAsUsd = (quote, { isForeign } = {}) =>
    !!(isForeign && hasValidTrm(quote))

const formatCertificateMoney = (value, { useUsd } = {}) => {
    if (value == null || Number.isNaN(Number(value))) return ''
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: useUsd ? 'USD' : 'COP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(Number(value))
}

const getAbleQuoteForOrderItem = item => item?.quotes?.find(q => q.able) || null

const getSupplierIdFromAbleQuote = (request, orderNumber) => {
    const items = (request?.items || []).filter(
        item => item.purchaseOrder?.orderNumber === orderNumber
    )
    for (const item of items) {
        const quote = getAbleQuoteForOrderItem(item)
        if (quote?.supplier?.id) return quote.supplier.id
    }
    return null
}

export {
    isForeignSupplierLanguage,
    isSpanishCertificateLanguage,
    hasValidTrm,
    getQuoteUnitPriceForCertificate,
    shouldFormatCertificateAsUsd,
    formatCertificateMoney,
    getAbleQuoteForOrderItem,
    getSupplierIdFromAbleQuote,
}
